<div class="modal-header">
    <h3 class="modal-title">Reinitialize Batch</h3>
</div>

<div class="modal-body">
    <div class="row" *ngIf="alert">
        <div class="col-12">
            <div class="alert" [ngClass]="{'alert-success' : alert.type == 'success', 'alert-default' : alert.type == 'default', 'alert-danger': alert.type == 'danger' }" role="alert">
                {{alert.msg}}
            </div>
        </div>
    </div>
    <div *ngIf="ProcessType == 'B' || ProcessType == 'P'">
        <div class="card border mt-3">
            <div class="card-header bg-light">
                <h3 class="card-title">Reprocess PR Expenses</h3>
            </div>
            <div class="card-body border">
                <div class="col-lg-12" style="margin-bottom:10px;">
                    This process will create a new PR Timecard Entry batch with all expense transactions from the selected batch.  Use this feature when you accidentally canceled a previous batch prior to finalization.
                </div>

                <div class="row">
                    <div class="col-lg-6">
                        <label><strong>Batch</strong></label>
                        <ng-select [(ngModel)]="formData.SelectedBatchP" name="Batch" [ngClass]="{'is-invalid' : formData.SelectedBatchP == null}"
                                   [items]="batchListP" bindLabel="display" bindValue="HQBCKeyID"
                                   [searchable]="false" [clearable]="false" dropdownPosition="bottom" [virtualScroll]="true">
                        </ng-select>
                    </div>
                    <div class="col-lg-6">
                        <label><strong>Pay Period</strong></label>
                        <ng-select [(ngModel)]="formData.SelectedPayPeriod" name="PayPeriod" [ngClass]="{'is-invalid' : formData.SelectedPayPeriod == null}" (change)="getPaySeq()"
                                   [items]="payPeriodList" bindLabel="PREndDateDisplay"
                                   [searchable]="false" [clearable]="false" dropdownPosition="bottom" [virtualScroll]="true">
                        </ng-select>
                    </div>
                </div>
                <div class="row" style="margin-top:10px;">
                    <div class="col-lg-6">
                        <label><strong>Pay Seq</strong></label>
                        <ng-select [(ngModel)]="formData.SelectedPaySeq" name="PaySeq" [ngClass]="{'is-invalid' : formData.SelectedPaySeq == null}"
                                   [items]="paySeqList" bindLabel="SeqDescription" bindValue="PaySeq"
                                   [searchable]="false" [clearable]="false" dropdownPosition="bottom" [virtualScroll]="true">
                        </ng-select>
                    </div>
                    <div class="col-lg-8">
                        <label><strong>Earn Code</strong></label>
                        <ng-select [(ngModel)]="formData.SelectedEarnCode" name="EarnCode"
                                   [items]="earnCodeList" bindLabel="DisplayName" bindValue="EarnCode"
                                   [searchable]="false" [clearable]="false" dropdownPosition="bottom" [virtualScroll]="true">
                        </ng-select>
                    </div>
                </div>
                <div style="margin-top:10px;">
                    <button class="btn btn-success" type="button" (click)="processClicked('P')" [disabled]="formData.SelectedPayPeriod == null || formData.SelectedPaySeq == null || formData.SelectedBatchP == null">Reprocess</button>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="ProcessType == 'A' || ProcessType == 'B'">
        <div class="card border mt-3">
            <div class="card-header bg-light">
                <h3 class="card-title">Reprocess AP Expenses</h3>
            </div>
            <div class="card-body border">
                <div class="col-lg-12" style="margin-bottom:10px;">
                    This process will create a new AP transaction batch containing all expense transactions from the selected batch.  Use this feature when you accidentally canceled a previous batch prior to finalization.
                </div>
                <div class="row col-lg-12">
                    <div class="col-lg-4">
                        <label><strong>Batch</strong></label>
                        <ng-select [(ngModel)]="formData.SelectedBatchA" name="Batch" [ngClass]="{'is-invalid' : formData.SelectedBatchA == null}"
                                   [items]="batchListA" bindLabel="display" bindValue="HQBCKeyID"
                                   [searchable]="false" [clearable]="false" dropdownPosition="bottom" [virtualScroll]="true">
                        </ng-select>
                    </div>
                    <div class="col-lg-4">
                        <div>
                            <label><strong>Reprocess Month:</strong></label>
                            <div class="input-group">
                                <input type="text" class="form-control" bsDatepicker #monthdp="bsDatepicker" [(ngModel)]="formData.selectedMonthA" [outsideClick]="true" name="ReprocessMonthA"
                                       [bsConfig]="datePickerOptionsMonth" style="background-color:#ffffff" (onShown)="onOpenCalendar($event)">
                                <div class="input-group-append">
                                    <button type="button" class="btn btn-outline-secondary" (click)="monthdp.show()" [attr.aria-expanded]="monthdp.isOpen" style="margin-right:0px">
                                        <i class="modus-icons align-bottom">calendar</i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4" *ngIf="showAPRef">
                        <div>
                            <label><strong>AP Reference #:</strong></label>
                            <div class="input-group">
                                <input type="text" class="form-control" [(ngModel)]="formData.aPRef" maxlength="12" style="background-color:#ffffff;" />
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3">
                        <button class="btn btn-success buttonNoLabel" type="button" (click)="processClicked('A')" [disabled]="formData.SelectedBatchA == null || formData.selectedMonthA == null">Process</button>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="card border mt-3">
        <div class="card-header bg-light">
            <h3 class="card-title">Reprocess Credit Card Expenses</h3>
        </div>
        <div class="card-body">
            <div class="col-lg-12" style="margin-bottom:10px;">
                This process will create a new Credit Card transaction batch containing all expense transactions from the selected batch.  Use this feature when you accidentally canceled a previous batch prior to finalization.
            </div>
            <div class="row col-lg-12">
                <div class="col-lg-4">
                    <label><strong>Batch</strong></label>
                    <ng-select [(ngModel)]="formData.SelectedBatchE" name="Batch" [ngClass]="{'is-invalid' : formData.SelectedBatchE == null}"
                               [items]="batchListE" bindLabel="display" bindValue="HQBCKeyID"
                               [searchable]="false" [clearable]="false" dropdownPosition="bottom" [virtualScroll]="true">
                    </ng-select>
                </div>
                <div class="col-lg-4">
                    <div>
                        <label><strong>Reprocess Month:</strong></label>
                        <div class="input-group">
                            <input type="text" class="form-control" bsDatepicker #monthdp="bsDatepicker" [(ngModel)]="formData.selectedMonthE" [outsideClick]="true" name="ReprocessMonthE"
                                   [bsConfig]="datePickerOptionsMonth" style="background-color:#ffffff" (onShown)="onOpenCalendar($event)">
                            <div class="input-group-append">
                                <button type="button" class="btn btn-outline-secondary" (click)="monthdp.show()" [attr.aria-expanded]="monthdp.isOpen" style="margin-right:0px">
                                    <i class="modus-icons align-bottom">calendar</i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row col-lg-12">
                <div class="col-lg-6" *ngIf="vendorList?.length > 0">
                    <label><strong>CC Vendor</strong></label>
                    <ng-select [(ngModel)]="formData.SelectedVendor" name="CCVendor"
                               [items]="vendorList" bindLabel="DisplayName" bindValue="KeyID"
                               [searchable]="false" [clearable]="false" dropdownPosition="bottom" [virtualScroll]="true">
                    </ng-select>
                </div>
                <div class="col-lg-2">
                    <button class="btn btn-success buttonNoLabel" type="button" (click)="processClicked('E')" [disabled]="formData.SelectedBatchE == null || formData.selectedMonthE == null">Process</button>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="cancelClicked()">Cancel</button>
</div>